import axios from 'axios';
import { OwnerType } from 'types/shared/owner-type.enum';
import { FeedStrategiesListItem } from '../types/feed-strategies-list-item.type';

//TODO a lot of feed strategy endpoints are shared in planning and prognosis. make shared CRUD folder and import them into subfeature's CRUD folder?

// GET
// /ewosapi/v2/planandprognosis/feedstrategy/{type}/{id}
// Fetches the list of feed strategies from SeaCloud.
export const getFeedStrategies = async (owner: OwnerType, id: string): Promise<FeedStrategiesListItem[]> => {
  const res = await axios.get<FeedStrategiesListItem[]>(`/ewosapi/v2/planandprognosis/feedstrategy/${owner}/${id}?filter=all`);
  return res.data;
};
